import React from "react";

import { connect } from "react-redux";
import {
    reset,
    listForVendor,
    assignTask,
    isLoading,
    isLoaded,
    getMeta,
    getList,
    getError,
    isSecondaryLoading,
    getSecondarySuccess,
} from "../../../../redux/actions/manager/purchaseOrder/form";

import {
    loadCache as loadCacheOld,
    isCacheLoading as isCacheLoadingOld,
    isCacheLoaded as isCacheLoadedOld,
    getProjectsForSelect,
    getPointOfSalesForSelect,
} from "../../../../redux/actions/cache";

import {
    CACHE_SERVICE,
    CACHE_VENDOR,
    CACHE_CLIENT,
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    getVendorsById,
    getVendorsForSelect,
    getClientsForSelect,
    getServicesById,
} from "../../../../redux/actions/cache/interface";

import {
    encodeQueryToURL,
    decodeQueryFromURL,
    onTableChangeUpdateUrl,
    onFilterChangeUpdateUrl,
} from "../../../../core/utils/list";

import { isNotValid, translateSymfonyErrorToFormik } from "../../../../core/utils/form";

import FullList from "../../../../core/components/listPattern/list";
import { PageHeader, Button, Descriptions, Badge, Divider } from "antd";

import { basicColumns } from "./fields";
import Filters from "./filters";
import Form from "./form";

/**
 * Container:
 *
 *   Se encarga de la conexion entre Redux y el Componente  que presenta los datos
 *
 * De paso en algunos caso, excepto formularios se maneja el Loading y el título.
 *
 * OBS: En formularios es mejor que el 'loading' lo maneje el formulario dado que Formik
 *    si se redibuja pierde los datos, entonces hay que tener cuidado con eso.
 */
class Container extends React.Component {
    constructor(props) {
        super(props);
        const defaultValues = {};
        const defaultHidden = [];
        defaultHidden["u.active"] = 1;
        this.state = {
            defaultValues,
            resize: [],
            hidden: defaultHidden,
            selectedRowKeys: null,
            id: props.match.params.id,
            code: props.match.params.code,
            vendorId: props.match.params.vendorId,
        };
    }

    componentDidMount() {
        const query = decodeQueryFromURL(this.props.history, this.state.defaultValues);

        const queryParams = { query };

        this.props.loadCache();
        this.props.loadCacheOld();
        this.props.listForVendor(query, this.state.vendorId);
    }

    componentDidUpdate(prevProps) {
        const { history } = this.props;

        if (history.location.search != prevProps.location.search) {
            const query = decodeQueryFromURL(history, this.state.defaultValues);

            this.props.listForVendor(query, this.state.vendorId);
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    _setColumns = (cols) => {
        this.setState({ columns: cols });
    };

    _onResize = (col, index) => (e, { size }) => {
        const nextResize = [...this.state.resize];
        nextResize[col] = size.width;
        this.setState({ resize: nextResize });
    };

    _onToggleVisible = (col) => {
        const nextHidden = this.state.hidden;
        const value = nextHidden[col] ? nextHidden[col] : 0;
        nextHidden[col] = value == 0 ? 1 : 0;
        this.setState({ hidden: nextHidden });
    };

    _onFilterChangeUpdateUrl = (form) => onFilterChangeUpdateUrl(this.props.history, form);
    _onTableChangeUpdateUrl = (pagination, filters, sorter) =>
        onTableChangeUpdateUrl(this.props.history, pagination, filters, sorter);

    onChange = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRowKeys,
            selectedRows,
        });
    };

    assignTask = () => {
        if (this.state.selectedRowKeys === null) {
            alert("Please select a task");
            return;
        }

        const ret = this.props.assignTask(this.state.id, this.state.selectedRowKeys);

        ret.then((response) => {
            if (this.props.formSuccess) {
                this._goBack();
                return;
            }
        }).catch((e) => {
            alert("Se ha producido un error desconocido");
        });

        return;
    };

    render() {
        const parameters = decodeQueryFromURL(this.props.history, this.state.defaultValues);
        const columns = basicColumns({
            ...this.props,
            filters: parameters,
            resize: this.state.resize,
            hidden: this.state.hidden,
        });
        return (
            <>
                <PageHeader
                    onBack={this._goBack}
                    ghost={false}
                    title={"Purchase Order PO-" + this.state.id}
                    subTitle="Vendor"
                    extra={[
                        <Button key="1" type="primary" onClick={this.assignTask}>
                            Add
                        </Button>,
                    ]}
                >
                    <Descriptions size="small" column={1} bordered>
                        <Descriptions.Item label="Code">{this.state.code}</Descriptions.Item>
                        <Descriptions.Item label="Status">
                            <Badge
                                status="warning"
                                text="Task should be COMPLETED, Job should be DELIVERED and belong to the same Vendor"
                            />
                        </Descriptions.Item>
                    </Descriptions>
                </PageHeader>
                <br />
                <br />

                <FullList
                    {...this.props}
                    titulo={"UNCOMPENSATED"}
                    subtitulo="Tasks"
                    onSearchByText={(text) => this._onFilterChangeUpdateUrl({ text })}
                    resize
                    columns={columns}
                    onResize={this._onResize}
                    onToggleVisible={this._onToggleVisible}
                    setColumns={this._setColumns}
                    filters={parameters}
                    onUpdateFilters={this._onFilterChangeUpdateUrl}
                    handleTableChange={this._onTableChangeUpdateUrl}
                    rowSelection={{
                        type: "radio",
                        onChange: this.onChange,
                    }}
                >
                    <Filters filters={parameters} onUpdateFilters={this._onFilterChangeUpdateUrl} {...this.props} />
                </FullList>
            </>
        );
    }
}
const cacheList = [CACHE_SERVICE, CACHE_VENDOR, CACHE_CLIENT];

function MapStateToProps(state) {
    return {
        meta: getMeta(state),
        data: getList(state),

        loading: isLoading(state) || isCacheLoading(state, cacheList) || isCacheLoadingOld(state),
        loaded: isLoaded(state) && isCacheLoaded(state, cacheList) && isCacheLoadedOld(state),

        formLoading: isSecondaryLoading(state),
        formSuccess: getSecondarySuccess(state),

        actionLoading: isSecondaryLoading(state),
        error: getError(state),

        vendors: getVendorsForSelect(state),
        clients: getClientsForSelect(state),
        projects: getProjectsForSelect(state),
        pointsOfSale: getPointOfSalesForSelect(state),

        vendorsById: getVendorsById(state),
        servicesById: getServicesById(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => loadCache(cacheList)(dispatch),
        loadCacheOld: () => loadCacheOld(["l3", "l4"])(dispatch),
        assignTask: (id, taskId) => dispatch(assignTask(id, taskId)),
        listForVendor: (query, vendor) => dispatch(listForVendor(query, vendor)),
        reset: () => dispatch(reset()),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
